import { getPage, getPageType, getGlobal, getAllProductPages } from 'lib/contentful';
import { fetchAllLocales } from 'lib/contentful/api';
import { useSalons } from 'hooks';
import SEO from 'components/shared/SEO';
import PageProduct from 'components/pages/product';
import Layout from 'components/layout';
import {
  reformatContentfulLocaleToLocale,
  reformatLocaleToContentfulLocale,
} from 'lib/utils/helpers';
import PageProductBundle from 'components/pages/productBundle/productBundle';
import PageBundleBuilder from 'components/pages/bundleBuilder';
import CountrySelectorModal from 'components/pages/countrySelector';

export default function Page({ page, locale, type, previewData, globalModules }) {
  useSalons(locale);

  // // If the page is not yet generated, this will be displayed
  // // initially until getStaticProps() finishes running
  // if (router.isFallback) {
  //   return <div>Loading...</div>;
  // }

  const renderPageContent = () => {
    switch (type) {
      case 'PageProduct':
        return <PageProduct locale={locale} data={page} resources={globalModules} />;
      case 'PageProductBundle':
        return <PageProductBundle locale={locale} data={page} resources={globalModules} />;
      case 'PageBundleBuilder':
        return <PageBundleBuilder locale={locale} data={page} resources={globalModules} />;
      default:
        return <div>{`Cannot find page type ${type}`}</div>;
    }
  };

  return (
    <Layout locale={locale} pageData={page} previewData={previewData} globalModules={globalModules}>
      <>
        {page?.seo && <SEO seo={page.seo} pageData={page} />}
        {renderPageContent()}
        <CountrySelectorModal globalModules={globalModules} pageData={page} locale={locale} />
      </>
    </Layout>
  );
}

export async function getStaticProps({ locale, params, preview = false, previewData = null }) {
  const { p } = params;

  const reformattedLocale = reformatLocaleToContentfulLocale(locale);
  const type = await getPageType(p, reformattedLocale);

  const page = await getPage(type, p, reformattedLocale, preview, null);

  if (!page) {
    return {
      notFound: true,
    };
  }

  const globalModuleNames = [
    'cookies',
    'announcement-bar',
    'countryselector',
    'firstcountryselectorlocales',
  ];

  if (type === 'PageProduct' || type === 'PageProductBundle') {
    globalModuleNames.push('productpage');
    globalModuleNames.push('secondpartproductpage');
    globalModuleNames.push('subscription');
  }

  const globalModules = await getGlobal(globalModuleNames, reformattedLocale);

  return {
    props: { page, locale, type, previewData, globalModules },
  };
}

export async function getStaticPaths() {
  const contentfulLocales = await fetchAllLocales();

  /*
  * contentfulLocales [
  'en',    'nl-NL', 'nl-BE',
  'hr',    'de-DE', 'fr',
  'sr',    'sl',    'en-US',
  'fr-BE', 'fr-FR', 'bs',
  'en-GB', 'es-ES', 'ro'
] */

  const allPages = [];
  const pagesPromises = [];

  const saveLocale = async locale => {
    const productPagesAndBundles = await getAllProductPages(locale);

    allPages.push(...productPagesAndBundles);
  };

  contentfulLocales.forEach(locale => {
    pagesPromises.push(saveLocale(reformatContentfulLocaleToLocale(locale)));
  });

  await Promise.all(pagesPromises);

  const finalPaths = [];

  allPages.forEach(page => {
    finalPaths.push({
      params: {
        p: page.slug,
      },
      locale: page.locale,
    });
  });

  return {
    paths: finalPaths,
    fallback: 'blocking',
  };
}
